
document.addEventListener( 'DOMContentLoaded', () => {
  
  var _itEl = document.querySelector('.image-with-text__heading em'); if (_itEl) _itEl.innerHTML ="<img src='https://www.solalune.fr/cdn/shop/files/Calque_1.svg' class='link-logo'>"
  
  const linkArea=document.querySelectorAll('.image-with-text')
  
    linkArea.forEach(area=>{
      if(area.querySelector('a')){
  
            if(area.querySelector('a').hasAttribute('href')){
                    //console.log(area.querySelector('a').getAttribute('href'))
              
                    area.addEventListener('click',()=>{
            
          
                              gtag('event', 'click_link_page', {
                                  'event_category': 'engagement',
                                  'event_label': 'Click link page item',
                                  'value': area.querySelector('a').getAttribute('href')
                                })
          
                                window.location=area.querySelector('a').getAttribute('href')
                      
                    })
            }
        
      }
    })


/*
  document.querySelectorAll('a').forEach(cta=>{

    console.log(cta)
    
  if(cta.hasAttribute('href')){
  
  cta.addEventListener('click',()=>(
        gtag('event', 'click_link_page', {
      'event_category': 'engagement',
      'event_label': 'Bouton link',
      'value': cta.getAttribute('href')
    })
  ))

  console.log(cta.getAttribute('href'))
  }
    
  })

*/

  
})